<ng-container *ngFor="let hotel of day">
  <div class="container mt-3">
    <div class="row">
      <div class="col-xs-12 col-md-4">
        <img class="img-fluid service-photo" [src]="hotel.hotels[0].image" alt="Hotel"
          [fallbackSrc]="noImageUrl"
          [secondaryFallback]="'assets/custom/' + version + '/images/logo_tour_operator.png'">
      </div>
  
      <div class="col-xs-12 col-md-8">
        <div class="row">
          <div class="col-xs-12 col-md-12">
            <h5>
              <span class="text-capitalize">
                {{ hotel.hotels[0]?.name | lowercase }}
              </span>
            </h5>
          </div>
          <!-- <div class="col-xs-12 col-md-4">
            <app-pnr [pnr]="hotel.hotels[0]?.pnr"></app-pnr>
          </div> -->
        </div>
  
        <div class="itinerary-content">
          <div class="itinerary-adress">
            <span class="itinerary-icons"><em class="fas fa-map-marker-alt"></em></span>
            <h6>
              <span class="text-capitalize">
                {{ hotel.hotels[0]?.address | lowercase }}
              </span>
              -
              <a class="small" href="https://www.google.it/maps/search/{{hotel.hotels[0]?.address}}"
                target="_blank" rel="noopener">
                {{ "ITINERARY.VIEW-ON-MAP" | translate }}
              </a>
            </h6>
          </div>
        </div>
  
        <div class="itinerary-content">
          <div class="itinerary-night">
            <span class="itinerary-icons"><app-service-icon [icon]="'hotel'" [customPath]="getServiceIconPath('hotel')"></app-service-icon></span>
            <h6>
              <span class="text-capitalize">
                {{ hotel.checkin | localizedDate: "dd MMM" }} -
                {{ hotel.checkout | localizedDate: "dd MMM" }}
              </span>
            </h6>
          </div>
          <app-room [rooms]="hotel.hotels[0]?.rooms"></app-room>
        </div>
  
        <p class="m-0 text-default" *ngIf="!replaceShowDescriptionButtonWithNotes && hotel.notes">
          <ng-container *ngFor="let item of hotel.notes">
            <ng-container *ngIf="state === 'Preventivo'">
              <ng-container *ngIf="item.id.endsWith('itinerario_preventivo')">
                <span [innerHTML]="item.text | safeHtml"></span>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="state === 'Confermata'">
              <ng-container *ngIf="item.id.endsWith('itinerario_conferma')">
                <span [innerHTML]="item.text | safeHtml"></span>
              </ng-container>
            </ng-container>
          </ng-container>
        </p>
        
        <!-- <app-carousel-images [images]="hotel.hotels[0]?.descriptive_info_content.images">
        </app-carousel-images> -->

        <div class="calculate-diff">
          <svg width="28" height="25" viewBox="0 0 28 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.6876 4.81234L14 7.18351L15.3124 4.81234C15.8209 3.89373 16.5627 3.12554 17.463 2.58535C18.3507 2.05273 19.3615 1.76036 20.396 1.73663C22.0777 1.82132 23.6599 2.56214 24.8021 3.801C25.9544 5.05075 26.5652 6.70574 26.5011 8.4044L26.5 8.43267V8.46096C26.5 10.6197 25.3431 13.0681 23.4293 15.5819C21.5426 18.0603 19.0688 20.4096 16.7694 22.3384L16.7683 22.3393C15.993 22.9908 15.0128 23.348 14 23.348C12.9873 23.348 12.007 22.9908 11.2317 22.3393L11.2307 22.3384C8.93123 20.4096 6.45748 18.0603 4.57074 15.5819C2.65697 13.0681 1.50003 10.6197 1.50003 8.46096V8.43267L1.49897 8.4044C1.43487 6.70574 2.04567 5.05075 3.19792 3.801C4.34013 2.56214 5.92236 1.82132 7.60411 1.73663C8.63857 1.76036 9.64936 2.05273 10.5371 2.58535C11.4374 3.12554 12.1792 3.89373 12.6876 4.81234Z" stroke="#F95A5A" stroke-width="3"/>
          </svg>            
          <span [innerHTML]="calculateDiff(hotel.hotels[0].rooms)"></span>
        </div>
      </div>
  
      <section class="col-12 right" *ngIf="replaceShowDescriptionButtonWithNotes; else alternativeDescriptionToggle">
        <span *ngIf="hotel.hotels[0]?.description" [innerHTML]="getTest(hotel.hotels[0]?.description) | safeHtml"></span>
        <details class="details details-hotel" *ngIf="getFilteredNotes(hotel.notes).length > 0">
          <summary class="text-right small" attr.data-open="{{ 'ITINERARY.SHOW' | translate }}"
            attr.data-close="{{ 'ITINERARY.HIDE' | translate }}">
          </summary>
          <div class="row">
            <div class="col-12">
              <ng-container *ngFor="let item of getFilteredNotes(hotel.notes)">
                <span [innerHTML]="item.text | safeHtml"></span>
              </ng-container>
            </div>
          </div>
        </details>
      </section>
      <ng-template #alternativeDescriptionToggle>
      <section class="col-12 right" *ngIf="hotel.hotels[0]?.description != ''">
        <details class="details details-hotel">
          <summary class="text-right small" attr.data-open="{{ 'ITINERARY.SHOW' | translate }}"
            attr.data-close="{{ 'ITINERARY.HIDE' | translate }}">
          </summary>
          <div class="row">
            <div class="col-12">
              <span [innerHTML]="getTest(hotel.hotels[0]?.description) | safeHtml"></span>
            </div>
          </div>
        </details>
      </section>
      </ng-template>
    </div>
  
    <div class="col-12 mt-2 mb-2"
      *ngIf="day.optionals != '' || (day.flights != '' && day.isLastDay != false)">
      <hr class="line-grey">
    </div>
  </div>
</ng-container>